/* eslint-disable */
// @ts-nocheck
// source: internal/realtime.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var internal_opportunity_pb = require('../internal/opportunity_pb.js');
goog.object.extend(proto, internal_opportunity_pb);
var internal_prompt_pb = require('../internal/prompt_pb.js');
goog.object.extend(proto, internal_prompt_pb);
var internal_info_gathering_pb = require('../internal/info_gathering_pb.js');
goog.object.extend(proto, internal_info_gathering_pb);
var internal_job_pb = require('../internal/job_pb.js');
goog.object.extend(proto, internal_job_pb);
var internal_job_progression_pb = require('../internal/job_progression_pb.js');
goog.object.extend(proto, internal_job_progression_pb);
var internal_job_scope_change_pb = require('../internal/job_scope_change_pb.js');
goog.object.extend(proto, internal_job_scope_change_pb);
var internal_job_event_pb = require('../internal/job_event_pb.js');
goog.object.extend(proto, internal_job_event_pb);
var internal_bookkeeping_pb = require('../internal/bookkeeping_pb.js');
goog.object.extend(proto, internal_bookkeeping_pb);
var internal_document_request_pb = require('../internal/document_request_pb.js');
goog.object.extend(proto, internal_document_request_pb);
var internal_job_tax_assistant_pb = require('../internal/job_tax_assistant_pb.js');
goog.object.extend(proto, internal_job_tax_assistant_pb);
goog.exportSymbol('proto.worklayer.internal.v1.RealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RealtimeEvent.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.StreamEventOptions', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.StreamEventOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.StreamEventOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.StreamEventOptions.displayName = 'proto.worklayer.internal.v1.StreamEventOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.RealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RealtimeEvent.displayName = 'proto.worklayer.internal.v1.RealtimeEvent';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.StreamEventOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.StreamEventOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.StreamEventOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.StreamEventOptions.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.StreamEventOptions}
 */
proto.worklayer.internal.v1.StreamEventOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.StreamEventOptions;
  return proto.worklayer.internal.v1.StreamEventOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.StreamEventOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.StreamEventOptions}
 */
proto.worklayer.internal.v1.StreamEventOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.StreamEventOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.StreamEventOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.StreamEventOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.StreamEventOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_ = [[1,2,3,4,5,6,7,8,9,10,11,12,13,16,14,15,17,18]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.RealtimeEvent.TypeCase = {
  TYPE_NOT_SET: 0,
  PING: 1,
  OPPORTUNITY_UPDATED: 2,
  OPPORTUNITY_REMOVED: 3,
  PROMPT_CREATED: 4,
  PROMPT_ANSWERED: 5,
  PROMPT_DELETED: 6,
  JOB_CREATED: 7,
  JOB_UPDATED: 8,
  JOB_PROGRESSION: 9,
  REQUESTED_SUPPORTING_ITEM_UPDATED: 10,
  OPPORTUNITY_OFFERED: 11,
  OPPORTUNITY_OFFER_REMOVED: 12,
  ADMIN_JOB_SCOPE_UPDATED: 13,
  JOB_SCOPE_CHANGE_APPROVED: 16,
  JOB_EVENT_RECORDED: 14,
  BOOKKEEPING_UPDATED: 15,
  DOCUMENT_REQUEST_CREATED: 17,
  JOB_TAX_ASSISTANT_UPDATED: 18
};

/**
 * @return {proto.worklayer.internal.v1.RealtimeEvent.TypeCase}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.RealtimeEvent.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    ping: (f = msg.getPing()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
    opportunityUpdated: (f = msg.getOpportunityUpdated()) && internal_opportunity_pb.Opportunity.toObject(includeInstance, f),
    opportunityRemoved: (f = msg.getOpportunityRemoved()) && internal_opportunity_pb.OpportunityRemovedRealtimeEvent.toObject(includeInstance, f),
    promptCreated: (f = msg.getPromptCreated()) && internal_prompt_pb.PromptCreatedRealtimeEvent.toObject(includeInstance, f),
    promptAnswered: (f = msg.getPromptAnswered()) && internal_prompt_pb.PromptAnsweredRealtimeEvent.toObject(includeInstance, f),
    promptDeleted: (f = msg.getPromptDeleted()) && internal_prompt_pb.PromptDeletedRealtimeEvent.toObject(includeInstance, f),
    jobCreated: (f = msg.getJobCreated()) && internal_job_pb.JobCreatedRealtimeEvent.toObject(includeInstance, f),
    jobUpdated: (f = msg.getJobUpdated()) && internal_job_pb.JobUpdatedRealtimeEvent.toObject(includeInstance, f),
    jobProgression: (f = msg.getJobProgression()) && internal_job_progression_pb.JobProgressionRealtimeEvent.toObject(includeInstance, f),
    requestedSupportingItemUpdated: (f = msg.getRequestedSupportingItemUpdated()) && internal_info_gathering_pb.RequestedSupportingItemUpdatedRealtimeEvent.toObject(includeInstance, f),
    opportunityOffered: (f = msg.getOpportunityOffered()) && internal_opportunity_pb.OpportunityOffer.toObject(includeInstance, f),
    opportunityOfferRemoved: (f = msg.getOpportunityOfferRemoved()) && internal_opportunity_pb.OpportunityOfferRemovedRealtimeEvent.toObject(includeInstance, f),
    adminJobScopeUpdated: (f = msg.getAdminJobScopeUpdated()) && internal_job_scope_change_pb.AdminJobScopeUpdatedRealtimeEvent.toObject(includeInstance, f),
    jobScopeChangeApproved: (f = msg.getJobScopeChangeApproved()) && internal_job_scope_change_pb.JobScopeChangeApprovedRealtimeEvent.toObject(includeInstance, f),
    jobEventRecorded: (f = msg.getJobEventRecorded()) && internal_job_event_pb.JobEventRecordedRealtimeEvent.toObject(includeInstance, f),
    bookkeepingUpdated: (f = msg.getBookkeepingUpdated()) && internal_bookkeeping_pb.BookkeepingUpdatedRealtimeEvent.toObject(includeInstance, f),
    documentRequestCreated: (f = msg.getDocumentRequestCreated()) && internal_document_request_pb.DocumentRequestSubmittedRealtimeEvent.toObject(includeInstance, f),
    jobTaxAssistantUpdated: (f = msg.getJobTaxAssistantUpdated()) && internal_job_tax_assistant_pb.JobTaxAssistantUpdatedRealtimeEvent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RealtimeEvent;
  return proto.worklayer.internal.v1.RealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setPing(value);
      break;
    case 2:
      var value = new internal_opportunity_pb.Opportunity;
      reader.readMessage(value,internal_opportunity_pb.Opportunity.deserializeBinaryFromReader);
      msg.setOpportunityUpdated(value);
      break;
    case 3:
      var value = new internal_opportunity_pb.OpportunityRemovedRealtimeEvent;
      reader.readMessage(value,internal_opportunity_pb.OpportunityRemovedRealtimeEvent.deserializeBinaryFromReader);
      msg.setOpportunityRemoved(value);
      break;
    case 4:
      var value = new internal_prompt_pb.PromptCreatedRealtimeEvent;
      reader.readMessage(value,internal_prompt_pb.PromptCreatedRealtimeEvent.deserializeBinaryFromReader);
      msg.setPromptCreated(value);
      break;
    case 5:
      var value = new internal_prompt_pb.PromptAnsweredRealtimeEvent;
      reader.readMessage(value,internal_prompt_pb.PromptAnsweredRealtimeEvent.deserializeBinaryFromReader);
      msg.setPromptAnswered(value);
      break;
    case 6:
      var value = new internal_prompt_pb.PromptDeletedRealtimeEvent;
      reader.readMessage(value,internal_prompt_pb.PromptDeletedRealtimeEvent.deserializeBinaryFromReader);
      msg.setPromptDeleted(value);
      break;
    case 7:
      var value = new internal_job_pb.JobCreatedRealtimeEvent;
      reader.readMessage(value,internal_job_pb.JobCreatedRealtimeEvent.deserializeBinaryFromReader);
      msg.setJobCreated(value);
      break;
    case 8:
      var value = new internal_job_pb.JobUpdatedRealtimeEvent;
      reader.readMessage(value,internal_job_pb.JobUpdatedRealtimeEvent.deserializeBinaryFromReader);
      msg.setJobUpdated(value);
      break;
    case 9:
      var value = new internal_job_progression_pb.JobProgressionRealtimeEvent;
      reader.readMessage(value,internal_job_progression_pb.JobProgressionRealtimeEvent.deserializeBinaryFromReader);
      msg.setJobProgression(value);
      break;
    case 10:
      var value = new internal_info_gathering_pb.RequestedSupportingItemUpdatedRealtimeEvent;
      reader.readMessage(value,internal_info_gathering_pb.RequestedSupportingItemUpdatedRealtimeEvent.deserializeBinaryFromReader);
      msg.setRequestedSupportingItemUpdated(value);
      break;
    case 11:
      var value = new internal_opportunity_pb.OpportunityOffer;
      reader.readMessage(value,internal_opportunity_pb.OpportunityOffer.deserializeBinaryFromReader);
      msg.setOpportunityOffered(value);
      break;
    case 12:
      var value = new internal_opportunity_pb.OpportunityOfferRemovedRealtimeEvent;
      reader.readMessage(value,internal_opportunity_pb.OpportunityOfferRemovedRealtimeEvent.deserializeBinaryFromReader);
      msg.setOpportunityOfferRemoved(value);
      break;
    case 13:
      var value = new internal_job_scope_change_pb.AdminJobScopeUpdatedRealtimeEvent;
      reader.readMessage(value,internal_job_scope_change_pb.AdminJobScopeUpdatedRealtimeEvent.deserializeBinaryFromReader);
      msg.setAdminJobScopeUpdated(value);
      break;
    case 16:
      var value = new internal_job_scope_change_pb.JobScopeChangeApprovedRealtimeEvent;
      reader.readMessage(value,internal_job_scope_change_pb.JobScopeChangeApprovedRealtimeEvent.deserializeBinaryFromReader);
      msg.setJobScopeChangeApproved(value);
      break;
    case 14:
      var value = new internal_job_event_pb.JobEventRecordedRealtimeEvent;
      reader.readMessage(value,internal_job_event_pb.JobEventRecordedRealtimeEvent.deserializeBinaryFromReader);
      msg.setJobEventRecorded(value);
      break;
    case 15:
      var value = new internal_bookkeeping_pb.BookkeepingUpdatedRealtimeEvent;
      reader.readMessage(value,internal_bookkeeping_pb.BookkeepingUpdatedRealtimeEvent.deserializeBinaryFromReader);
      msg.setBookkeepingUpdated(value);
      break;
    case 17:
      var value = new internal_document_request_pb.DocumentRequestSubmittedRealtimeEvent;
      reader.readMessage(value,internal_document_request_pb.DocumentRequestSubmittedRealtimeEvent.deserializeBinaryFromReader);
      msg.setDocumentRequestCreated(value);
      break;
    case 18:
      var value = new internal_job_tax_assistant_pb.JobTaxAssistantUpdatedRealtimeEvent;
      reader.readMessage(value,internal_job_tax_assistant_pb.JobTaxAssistantUpdatedRealtimeEvent.deserializeBinaryFromReader);
      msg.setJobTaxAssistantUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPing();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = message.getOpportunityUpdated();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      internal_opportunity_pb.Opportunity.serializeBinaryToWriter
    );
  }
  f = message.getOpportunityRemoved();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      internal_opportunity_pb.OpportunityRemovedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getPromptCreated();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      internal_prompt_pb.PromptCreatedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getPromptAnswered();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      internal_prompt_pb.PromptAnsweredRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getPromptDeleted();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      internal_prompt_pb.PromptDeletedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getJobCreated();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      internal_job_pb.JobCreatedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getJobUpdated();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      internal_job_pb.JobUpdatedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getJobProgression();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      internal_job_progression_pb.JobProgressionRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getRequestedSupportingItemUpdated();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      internal_info_gathering_pb.RequestedSupportingItemUpdatedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getOpportunityOffered();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      internal_opportunity_pb.OpportunityOffer.serializeBinaryToWriter
    );
  }
  f = message.getOpportunityOfferRemoved();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      internal_opportunity_pb.OpportunityOfferRemovedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getAdminJobScopeUpdated();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      internal_job_scope_change_pb.AdminJobScopeUpdatedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getJobScopeChangeApproved();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      internal_job_scope_change_pb.JobScopeChangeApprovedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getJobEventRecorded();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      internal_job_event_pb.JobEventRecordedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getBookkeepingUpdated();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      internal_bookkeeping_pb.BookkeepingUpdatedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getDocumentRequestCreated();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      internal_document_request_pb.DocumentRequestSubmittedRealtimeEvent.serializeBinaryToWriter
    );
  }
  f = message.getJobTaxAssistantUpdated();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      internal_job_tax_assistant_pb.JobTaxAssistantUpdatedRealtimeEvent.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Empty ping = 1;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getPing = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 1));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setPing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearPing = function() {
  return this.setPing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasPing = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Opportunity opportunity_updated = 2;
 * @return {?proto.worklayer.internal.v1.Opportunity}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getOpportunityUpdated = function() {
  return /** @type{?proto.worklayer.internal.v1.Opportunity} */ (
    jspb.Message.getWrapperField(this, internal_opportunity_pb.Opportunity, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.Opportunity|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setOpportunityUpdated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearOpportunityUpdated = function() {
  return this.setOpportunityUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasOpportunityUpdated = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional OpportunityRemovedRealtimeEvent opportunity_removed = 3;
 * @return {?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getOpportunityRemoved = function() {
  return /** @type{?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_opportunity_pb.OpportunityRemovedRealtimeEvent, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setOpportunityRemoved = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearOpportunityRemoved = function() {
  return this.setOpportunityRemoved(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasOpportunityRemoved = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PromptCreatedRealtimeEvent prompt_created = 4;
 * @return {?proto.worklayer.internal.v1.PromptCreatedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getPromptCreated = function() {
  return /** @type{?proto.worklayer.internal.v1.PromptCreatedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_prompt_pb.PromptCreatedRealtimeEvent, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.PromptCreatedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setPromptCreated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearPromptCreated = function() {
  return this.setPromptCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasPromptCreated = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PromptAnsweredRealtimeEvent prompt_answered = 5;
 * @return {?proto.worklayer.internal.v1.PromptAnsweredRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getPromptAnswered = function() {
  return /** @type{?proto.worklayer.internal.v1.PromptAnsweredRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_prompt_pb.PromptAnsweredRealtimeEvent, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.PromptAnsweredRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setPromptAnswered = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearPromptAnswered = function() {
  return this.setPromptAnswered(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasPromptAnswered = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PromptDeletedRealtimeEvent prompt_deleted = 6;
 * @return {?proto.worklayer.internal.v1.PromptDeletedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getPromptDeleted = function() {
  return /** @type{?proto.worklayer.internal.v1.PromptDeletedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_prompt_pb.PromptDeletedRealtimeEvent, 6));
};


/**
 * @param {?proto.worklayer.internal.v1.PromptDeletedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setPromptDeleted = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearPromptDeleted = function() {
  return this.setPromptDeleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasPromptDeleted = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional JobCreatedRealtimeEvent job_created = 7;
 * @return {?proto.worklayer.internal.v1.JobCreatedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getJobCreated = function() {
  return /** @type{?proto.worklayer.internal.v1.JobCreatedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_job_pb.JobCreatedRealtimeEvent, 7));
};


/**
 * @param {?proto.worklayer.internal.v1.JobCreatedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setJobCreated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearJobCreated = function() {
  return this.setJobCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasJobCreated = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional JobUpdatedRealtimeEvent job_updated = 8;
 * @return {?proto.worklayer.internal.v1.JobUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getJobUpdated = function() {
  return /** @type{?proto.worklayer.internal.v1.JobUpdatedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_job_pb.JobUpdatedRealtimeEvent, 8));
};


/**
 * @param {?proto.worklayer.internal.v1.JobUpdatedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setJobUpdated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearJobUpdated = function() {
  return this.setJobUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasJobUpdated = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional JobProgressionRealtimeEvent job_progression = 9;
 * @return {?proto.worklayer.internal.v1.JobProgressionRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getJobProgression = function() {
  return /** @type{?proto.worklayer.internal.v1.JobProgressionRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_job_progression_pb.JobProgressionRealtimeEvent, 9));
};


/**
 * @param {?proto.worklayer.internal.v1.JobProgressionRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setJobProgression = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearJobProgression = function() {
  return this.setJobProgression(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasJobProgression = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional RequestedSupportingItemUpdatedRealtimeEvent requested_supporting_item_updated = 10;
 * @return {?proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getRequestedSupportingItemUpdated = function() {
  return /** @type{?proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_info_gathering_pb.RequestedSupportingItemUpdatedRealtimeEvent, 10));
};


/**
 * @param {?proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setRequestedSupportingItemUpdated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearRequestedSupportingItemUpdated = function() {
  return this.setRequestedSupportingItemUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasRequestedSupportingItemUpdated = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional OpportunityOffer opportunity_offered = 11;
 * @return {?proto.worklayer.internal.v1.OpportunityOffer}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getOpportunityOffered = function() {
  return /** @type{?proto.worklayer.internal.v1.OpportunityOffer} */ (
    jspb.Message.getWrapperField(this, internal_opportunity_pb.OpportunityOffer, 11));
};


/**
 * @param {?proto.worklayer.internal.v1.OpportunityOffer|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setOpportunityOffered = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearOpportunityOffered = function() {
  return this.setOpportunityOffered(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasOpportunityOffered = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional OpportunityOfferRemovedRealtimeEvent opportunity_offer_removed = 12;
 * @return {?proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getOpportunityOfferRemoved = function() {
  return /** @type{?proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_opportunity_pb.OpportunityOfferRemovedRealtimeEvent, 12));
};


/**
 * @param {?proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setOpportunityOfferRemoved = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearOpportunityOfferRemoved = function() {
  return this.setOpportunityOfferRemoved(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasOpportunityOfferRemoved = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional AdminJobScopeUpdatedRealtimeEvent admin_job_scope_updated = 13;
 * @return {?proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getAdminJobScopeUpdated = function() {
  return /** @type{?proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_job_scope_change_pb.AdminJobScopeUpdatedRealtimeEvent, 13));
};


/**
 * @param {?proto.worklayer.internal.v1.AdminJobScopeUpdatedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setAdminJobScopeUpdated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearAdminJobScopeUpdated = function() {
  return this.setAdminJobScopeUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasAdminJobScopeUpdated = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional JobScopeChangeApprovedRealtimeEvent job_scope_change_approved = 16;
 * @return {?proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getJobScopeChangeApproved = function() {
  return /** @type{?proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_job_scope_change_pb.JobScopeChangeApprovedRealtimeEvent, 16));
};


/**
 * @param {?proto.worklayer.internal.v1.JobScopeChangeApprovedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setJobScopeChangeApproved = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearJobScopeChangeApproved = function() {
  return this.setJobScopeChangeApproved(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasJobScopeChangeApproved = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional JobEventRecordedRealtimeEvent job_event_recorded = 14;
 * @return {?proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getJobEventRecorded = function() {
  return /** @type{?proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_job_event_pb.JobEventRecordedRealtimeEvent, 14));
};


/**
 * @param {?proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setJobEventRecorded = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearJobEventRecorded = function() {
  return this.setJobEventRecorded(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasJobEventRecorded = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent bookkeeping_updated = 15;
 * @return {?proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getBookkeepingUpdated = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_bookkeeping_pb.BookkeepingUpdatedRealtimeEvent, 15));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setBookkeepingUpdated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearBookkeepingUpdated = function() {
  return this.setBookkeepingUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasBookkeepingUpdated = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional worklayer.internal.document_request.v1.DocumentRequestSubmittedRealtimeEvent document_request_created = 17;
 * @return {?proto.worklayer.internal.document_request.v1.DocumentRequestSubmittedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getDocumentRequestCreated = function() {
  return /** @type{?proto.worklayer.internal.document_request.v1.DocumentRequestSubmittedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_document_request_pb.DocumentRequestSubmittedRealtimeEvent, 17));
};


/**
 * @param {?proto.worklayer.internal.document_request.v1.DocumentRequestSubmittedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setDocumentRequestCreated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearDocumentRequestCreated = function() {
  return this.setDocumentRequestCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasDocumentRequestCreated = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional worklayer.internal.job_tax_assistant.v1.JobTaxAssistantUpdatedRealtimeEvent job_tax_assistant_updated = 18;
 * @return {?proto.worklayer.internal.job_tax_assistant.v1.JobTaxAssistantUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.getJobTaxAssistantUpdated = function() {
  return /** @type{?proto.worklayer.internal.job_tax_assistant.v1.JobTaxAssistantUpdatedRealtimeEvent} */ (
    jspb.Message.getWrapperField(this, internal_job_tax_assistant_pb.JobTaxAssistantUpdatedRealtimeEvent, 18));
};


/**
 * @param {?proto.worklayer.internal.job_tax_assistant.v1.JobTaxAssistantUpdatedRealtimeEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RealtimeEvent.prototype.setJobTaxAssistantUpdated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 18, proto.worklayer.internal.v1.RealtimeEvent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.clearJobTaxAssistantUpdated = function() {
  return this.setJobTaxAssistantUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RealtimeEvent.prototype.hasJobTaxAssistantUpdated = function() {
  return jspb.Message.getField(this, 18) != null;
};


goog.object.extend(exports, proto.worklayer.internal.v1);
